import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface FooterData {
  account: string
  date: string
}

interface FooterProps {
  footer: FooterData
}

const Footer = ({ footer }: FooterProps) => {
  return (
    <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', px: 16, py: 8 }}>
      <Text color="secondary" variant="tiny">
        {footer.date}
      </Text>
      <Text color="secondary" variant="tiny">
        {footer.account}
      </Text>
    </Stack>
  )
}

export default Footer
